import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useStore } from 'providers';
import { sendOnboardedStatus } from 'services/loyaltyGateway';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { useFetchFromService } from 'hooks';
import Loader from 'components/Loader';
import Welcome from 'views/Welcome';
import OnboardingScreen from 'views/OnboardingScreen';

const Home = () => {
  const { store, dispatch } = useStore();
  const { onboardedStatus, surveyQuestions } = store;
  const { onboarded } = onboardedStatus || { onboarded: false };
  const [isNewSignUp, setIsNewSignUp] = useState<boolean>(false);

  const fetchOnboardedStatus = useFetchFromService('onboardedStatus');
  const fetchSurveyQuestions = useFetchFromService('surveyQuestions');

  const shouldFetchOnboardingStatus = !onboardedStatus;
  const shouldFetchSurveyQuestions = onboardedStatus && !onboarded && !surveyQuestions;
  const isLoading = !onboardedStatus || (!onboarded && !surveyQuestions);

  useEffect(() => {
    if (shouldFetchOnboardingStatus) fetchOnboardedStatus();
  }, [shouldFetchOnboardingStatus, fetchOnboardedStatus]);

  useEffect(() => {
    if (shouldFetchSurveyQuestions) fetchSurveyQuestions();
  }, [shouldFetchSurveyQuestions, fetchSurveyQuestions]);

  const handleOnDone = () => {
    sendOnboardedStatus();
    dispatch({
      type: 'setOnboardedStatus',
      payload: { onboardedStatus: { onboarded: true } },
    });
    setIsNewSignUp(true);
    sessionStorage.setItem('showWelcomeNotification', 'true');
    localStorage.setItem('memberSince', dayjs().toISOString());
    pushAnalyticsEvent({ event: 'signUp' });
  };

  if (isLoading) return <Loader />;

  if (!onboarded) {
    return <OnboardingScreen onDone={handleOnDone} />;
  }

  return <Welcome isNewSignUp={isNewSignUp} />;
};

export default Home;
